/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
let finBase = window._env_.VUE_APP_FIN_CENTER_HOST


export const getCustomerProjectTable = params => {
  return axios.post(`${base}/statistic_project`, params)
}
export const createCustomerProject = params => {
  return axios.post(`${base}/create_project`, params)
}
export const updateCustomerProject = params => {
  return axios.post(`${base}/edit_project_${params.id}`, params)
}
export const updateCustomerProjectBeforeAudit = params => {
  return axios.post(`${base}/edit_project_unaudited_${params.id}`, params)
}

export const updateProjectStatus = params => {
  return axios.post(`${base}/edit_project_status_${params.id}`, params)
}
export const deleteProjectData = params => {
  return axios.post(`${base}/delete_project_${params.id}`)
}

// 财务信息
export const updateProjectFinanceData = params => {
  return axios.post(`${base}/edit_project_finance_${params.id}`, params)
}
export const getProjectFinanceDetail = params => {
  return axios.get(`${base}/get_project_finance_${params.id}`, {params})
}

// 预算调整
export const updateProjectBudget = params => {
  return axios.post(`${base}/edit_project_budget_${params.id}`, params)
}
export const updateProjectBudget4Ajx = params => {
  return axios.post(`${base}/ajx/edit_project_budget_${params.id}`, params)
}
export const getProjectBudgetTable = params => {
  return axios.post(`${base}/query_project_budget_${params.projectid}`, params)
}

// 预算使用详情
export const getProjectBudgetUseDetail = params => {
  return axios.get(`${finBase}/project/${params.projectid}/budget/statistic`, {params})
}

// 项目明细
export const getProjectFlowTable = params => {
  return axios.post(`${base}/query_project_flow_${params.projectid}`, params)
}

// 项目明细
export const uploadProjectFile = params => {
  return axios.post(`${base}/project/uploadfile`, params)
}

// 创建项目时获取默认配置（审批人，收件人等）
export const getProjectDefaultConfig = params => {
  // return axios.get(`${base}/get_project_default_config`, {params})
  return axios.get(`${base}/setting/get_project_config`, {params})
}



// WEBPACK FOOTER //
// ./src/views/customer-project/customer-project.api.js